var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFornecedor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add-fornecedor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.004,
    height: 15.441,
    viewBox: "0 0 17.004 15.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1703",
    "data-name": "Caminho 1703",
    d: "M182.243,151.577a.854.854,0,0,1-.634.613,1.189,1.189,0,0,1-.231.019c-.531,0-1.063,0-1.594,0h-.2v.19c0,.544,0,1.087,0,1.631a.8.8,0,1,1-1.594,0c0-.6,0-1.2,0-1.821h-.182c-.543,0-1.085,0-1.628,0a.8.8,0,1,1,0-1.6c.537,0,1.074,0,1.611,0h.2v-.191c0-.544,0-1.087,0-1.631a.8.8,0,1,1,1.594,0c0,.6,0,1.2,0,1.821h.182c.487,0,.975.018,1.461,0a.9.9,0,0,1,1.014.637Z",
    transform: "translate(-165.239 -139.431)",
    fill: "#9f0010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1704",
    "data-name": "Caminho 1704",
    d: "M4.186,7.3a4.26,4.26,0,1,1,5.975,0c.148.077.3.142.435.229.332.21.667.417.983.648a.8.8,0,1,1-.966,1.267A5.273,5.273,0,0,0,8.479,8.416a1.734,1.734,0,0,0-.616.043A4.423,4.423,0,0,1,6.2,8.407a.757.757,0,0,0-.324,0,5.586,5.586,0,0,0-4.242,4.747c-.027.219-.033.441-.051.687h9.525a.8.8,0,0,1,.1,1.6c-.055,0-.111,0-.166,0H1.707A1.583,1.583,0,0,1,0,13.709,7.083,7.083,0,0,1,4.027,7.383L4.186,7.3M9.829,4.25A2.657,2.657,0,1,0,7.173,6.92,2.662,2.662,0,0,0,9.829,4.25",
    transform: "translate(0 0)",
    fill: "#9f0010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFornecedor);
export default __webpack_public_path__ + "static/media/add-fornecedor.b89e40625091ea3b87a5433e7a7e53a5.svg";
export { ForwardRef as ReactComponent };